import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkScrollableModule } from '@angular/cdk/scrolling';

import { DraggableScrollDirective } from './draggable-scroll.directive';
import { ScrollbarComponent } from './scrollbar.component';

@NgModule({
  declarations: [DraggableScrollDirective, ScrollbarComponent],
  imports: [CommonModule, CdkScrollableModule],
  exports: [ScrollbarComponent]
})
export class ScrollbarModule {}
